const officerStatus = [
    { label: 'In line with Pertamina Vetting Criteria', value: 'In line with Pertamina Vetting Criteria' },
    { label: 'Not In line with Pertamina Vetting Criteria', value: 'Not In line with Pertamina Vetting Criteria' }
];

export default officerStatus;
